// @ is an alias to /src
import MainPage from '@/components/Home/MainPage.vue'
import MainInfo from '@/components/Home/MainInfo.vue'
import dayjs from 'dayjs'

export default {
  name: 'HomeView',
  components: {
    MainPage, MainInfo
  },
  data () {
    return {
      notice: [],
      popList: [],
      modal: false,
      filePath: '',
      today: dayjs().format('YYYY-MM-DD HH:mm')
    }
  },
  async created () {
    this.notice = await this.$get('home/board?commCode=00')
    if (this.notice.detail.length !== 0) {
      for (let i = 0; i < this.notice.detail.length; i++) {
        if (this.notice.detail[i].popStDate !== '' && this.notice.detail[i].popStDate <= this.today && this.notice.detail[i].popEdDate >= this.today) {
          if (!this.$cookies.isKey('popup')) this.modal = true
          this.popList.push(this.notice.detail[i])
        }
      }
    }
  },
  methods: {
    isCookie () {
      this.$cookies.remove('popup')
      this.$cookies.set('popup', 'popValue', '1d')
      this.modalClose()
    },
    modalClose () {
      this.modal = false
    }
  }
}
